import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BillingDetails } from 'models/BillingDetails'

// Define the initial state for the slice
const initialState: BillingDetails = {
  address: {
    city: '',
    country: '',
    line1: '',
    state: '',
  },
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  isCompanyCard: false,
}

// Define the `billingDetails` slice
export const billingDetailsSlice = createSlice({
  name: 'billingDetails',
  initialState,
  reducers: {
    // Reducer to update the billing details
    updateBillingDetails: (state, action: PayloadAction<Partial<BillingDetails>>) => {
      return { ...state, ...action.payload }
    },
  },
})

// Export the `setBillingDetails` and `updateBillingDetails` actions
export const { updateBillingDetails } = billingDetailsSlice.actions

// Export the `billingDetails` reducer
export default billingDetailsSlice.reducer
